module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-96b87e0b.png";